const shopDetailItem = document.querySelectorAll('.js-shopDetailItem');
// 基本的な処理を行う関数
function addActiveClass(elements, currentIndex, elements2, wordItems, singleWordItem) {
  elements[currentIndex].classList.add('active');
  if (elements2[currentIndex]) elements2[currentIndex].classList.add('active');
  if (!singleWordItem && wordItems[currentIndex]) {
    wordItems[currentIndex].classList.add('active');
  } else if (singleWordItem) {
    wordItems[0].classList.add('active');
  }
}

function removeActiveClass(elements, currentIndex, elements2, wordItems, singleWordItem) {
  elements[currentIndex].classList.remove('active');
  if (elements2[currentIndex]) elements2[currentIndex].classList.remove('active');
  if (!singleWordItem && wordItems[currentIndex]) {
    wordItems[currentIndex].classList.remove('active');
  }
}

function clickEvent(elements, currentIndex, elements2, wordItems, singleWordItem) {
  removeActiveClass(elements, currentIndex, elements2, wordItems, singleWordItem);
  currentIndex = (currentIndex + 1) % elements.length;
  addActiveClass(elements, currentIndex, elements2, wordItems, singleWordItem);
  return currentIndex;
}

shopDetailItem.forEach((item) => {
  const thumbnails = item.querySelector('.js-thumbnails');
  const pointers = item.querySelector('.js-pointers');
  const gokainWord = item.querySelector('.js-gokainWord');
  if (!thumbnails || !gokainWord) return;

  const ulChild = Array.from(thumbnails.children); // ulChildにli要素を配列にして格納
  const ul2Child = Array.from(pointers.children);  // ul2Childにli要素を配列にして格納
  const ul3Child = Array.from(gokainWord.children);  // ul3Childにli要素を配列にして格納
  let currentIndex = 0;

  // word-item が1つしかない場合の特別な処理
  const singleWordItem = ul3Child.length === 1;

  if (ulChild.length <= 1) { // li要素が1つ以下の場合は処理
    pointers.style.display = 'none';
    ulChild[currentIndex].classList.add('active');
    ul3Child[0].classList.add('active'); // word-item が1つしかない場合
    return;
  }

  addActiveClass(ulChild, currentIndex, ul2Child, ul3Child, singleWordItem); // 初期表示

  // 各サムネイルandインジゲーターにクリックイベントを追加
  thumbnails.addEventListener('click', () => {
    currentIndex = clickEvent(ulChild, currentIndex, ul2Child, ul3Child, singleWordItem);
  });
  pointers.addEventListener('click', () => {
    currentIndex = clickEvent(ul2Child, currentIndex, ulChild, ul3Child, singleWordItem);
  });
});

